import React, {useEffect, useState} from 'react';
import GameThumbnail from './GameThumbnail';
import {GameData} from './types';
import SERVER from './serverUrl';

function PredefinedGames({handleClick = (e : React.MouseEvent<HTMLDivElement, MouseEvent>) => { }}) {

    const [isLoading, setIsLoading] = useState(true);
    const [gameArray, setGameArray] = useState<Array<GameData>>([])
    useEffect(() => {
        fetch(`${SERVER}/predefinedGames`)
            .then(response => {
                if (response.ok) {
                    return response.json()
                }
            })
            .then(data=> {
                setGameArray(data.games);
                console.log(data);
            })
            .catch(error => {
                console.error("Error fetching data: ", error);
            })
            .finally(() => {
                setIsLoading(false);
            })

    }, [])

    return (
        <>
            <h3>Predefined Games</h3>
            <div className="predefinedGames" >
             {isLoading ? <div>"Loading..."</div> : gameArray.map((value, index) => 
             <div className="predefinedGame" key={index} 
                onClick={handleClick} 
                data-gameid={value.name} 
                data-gamestate={value.stateKey}>{value.name}<GameThumbnail game={value}/></div>)}
            </div>        
        </>
  );
}

export default PredefinedGames;
